<template>
  <div class="empty-state">
    <div class="empty-state-content">
      <img src="../../../assets/table-loading.png" alt="Loading" class="empty-state-image" />
      <p class="empty-state-text">No application data available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
}
</script>

<style scoped>
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: #f8f9fa;
  border-radius: 8px;
}

.empty-state-content {
  text-align: center;
}

.empty-state-image {
  max-width: 200px;
  opacity: 0.6;
  margin-bottom: 20px;
}

.empty-state-text {
  color: #6c757d;
  font-size: 16px;
  margin: 0;
}
</style>
